var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFooterIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 23,
    height: 23,
    viewBox: "0 0 23 23",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 11.5,
    cy: 11.5,
    r: 11.5,
    fill: "#DC1800"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.2079 9.0207L17.1054 5.16327H6.57141V17.909H11.3254V14.9622L15.18 14.9969L16.0784 11.1395H11.3254V9.0207H16.2079ZM16.3159 5.79037L15.7104 8.3936H11.3254V5.79037H16.3159ZM10.6983 5.79037V7.90449L8.17108 5.79037H10.6983ZM7.87443 11.7666H10.6983V14.0769L7.87443 11.7666ZM7.20227 17.2819V12.2322L10.702 14.9876V17.2819H7.20227ZM15.2926 11.7666L14.6862 14.3698H11.3254V11.7666H15.2926ZM7.29615 11.1395H7.20227V5.79413L10.702 8.72217V11.1395H7.29615Z",
    fill: "white"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFooterIcon);
export default __webpack_public_path__ + "static/media/footer-icon.77f1aad5.svg";
export { ForwardRef as ReactComponent };